/**
 * Header Animation Module
 *
 * When the user scrolls past 500px, add `is-scrolled` to #masthead so it
 * picks up the Site Settings background and dark header style.
 */

const SCROLL_THRESHOLD_PX = 500;

/**
 * Initialize header scroll behavior
 */
function initHeaderScrollBehavior() {
  const header = document.getElementById("masthead");
  if (!header) return;

  const body = document.body;
  const originalHeaderStyle = body.classList.contains("header-style-light")
    ? "light"
    : "dark";

  function applyScrolledState(isScrolled) {
    header.classList.toggle("is-scrolled", isScrolled);
    body.classList.toggle("header-is-scrolled", isScrolled);

    // Force dark header style while scrolled; restore original when not
    if (isScrolled) {
      body.classList.remove("header-style-light");
      body.classList.add("header-style-dark");
      header.classList.remove("header-style-light");
      header.classList.add("header-style-dark");
    } else if (originalHeaderStyle === "light") {
      body.classList.remove("header-style-dark");
      body.classList.add("header-style-light");
      header.classList.remove("header-style-dark");
      header.classList.add("header-style-light");
    }
  }

  function handleScroll() {
    applyScrolledState(window.scrollY >= SCROLL_THRESHOLD_PX);
  }

  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      handleScroll();
      ticking = false;
    });
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  handleScroll();
}

export { initHeaderScrollBehavior };
